<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getOfficesResponse from "@/types/responses/getOffices"
import { Ref, onMounted, ref, computed } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue']);
const props = withDefaults(
  defineProps<{
    modelValue: officeType
    selectedOfficeableType: {
      id: number | null,
      name: string,
      type: string }
      errorMessages: string[]
      readonly?: boolean
      clearable?: boolean
    }>(),
  {
    readonly: false,
    clearable: true,
  }
)

type officeType = {
  id: number | null,
  type: string,
  name: string,
  departments: any[]
}

const items: Ref<getOfficesResponse[]> = ref([])

onMounted(() => {
  Api().getOffices().then((data: getOfficesResponse[]) => {
    data.forEach((office: getOfficesResponse) => {
      items.value.push({
        id: office.id,
        type: office.type.split('\\')[2],
        name: office.company_name ?? office.operation_office_name,
        departments: office.departments ?? []
      })
    })
  })
})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const selectableItems = computed(() => {
  if (!props.selectedOfficeableType.type) return items.value
  return items.value.filter((item) => {
    return item.type === props.selectedOfficeableType.type
  })
})
</script>
<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    :label="i18n.global.t('pages.common.filter.organization')"
    itemName="name"
    :items="selectableItems"
    :selectFirstIfOnlyOne="true"
    :clearable="clearable"
    :readonly="readonly"
    :error-messages="errorMessages"
  />
</template>